import * as React from "react";
const SvgMinusSmallBold = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12.666 7.25a.75.75 0 0 1 0 1.5H3.333a.75.75 0 0 1 0-1.5z" /></svg>;
export default SvgMinusSmallBold;